import React from "react";
import PropTypes from "prop-types";
import LaTeX from "react-latex";
import TextBlock from "./TextBlock";

/**
 * TeXBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block renderer for LaTeX text using
 * the Katex typesetting engine
 *
 * @param {*} props
 */
const TeXBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      <LaTeX displayMode>{`$$${props.block.text}$$`}</LaTeX>
    ) : (
      <TextBlock {...props} placeholder={"manuscript.blocks.tex.placeholder"} />
    )}
  </div>
);

TeXBlock.propTypes = {
  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default TeXBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/text/TeXBlock.js